export const hasPermission = (permission, data = []) => {
  let newArr = data.filter((e) => e);
  return newArr.includes(permission);
};
